import config from '../../config/config';

export const PAYOUT_RECIPIENT_LOAD = 'PAYOUT_RECIPIENT/PAYOUT_RECIPIENT_LOAD';
export const PAYOUT_RECIPIENT_SUCCESS = 'PAYOUT_RECIPIENT/PAYOUT_RECIPIENT_SUCCESS';
export const PAYOUT_RECIPIENT_FAILURE = 'PAYOUT_RECIPIENT/PAYOUT_RECIPIENT_FAILURE';

export function getPayoutRecipientFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_RECIPIENT_FAILURE
    };
}

export function getPayoutRecipientSuccessActionCreator(recipient) {
    return {
        recipient,
        type: PAYOUT_RECIPIENT_SUCCESS
    };
}

export function getPayoutRecipient(recipientId) {
    return {
        failureActionTypeOrCreator: getPayoutRecipientFailureActionCreator,
        fetchParams: {
            url: `${config.payoutApiUrl}/recipient/${recipientId}`
        },
        loadActionTypeOrCreator: PAYOUT_RECIPIENT_LOAD,
        successActionTypeOrCreator: getPayoutRecipientSuccessActionCreator
    };
}
